<template>
  <div class="usertenter">
    <!-- 头标签 -->
    <div class="usertop">
      <div style="width: 400px;height: 200px;float: left;">
        <img
          src="../../imges/user/logo-index.png"
          style="width: 100%;height: 100%;"
          alt=""
        />
      </div>
      <div style="width: 500px;height: 200px;float: left;">
        <div
          style="width: 500px;height: 100px;line-height: 100px;font-size: 30px;text-align: center;font-weight: 800;color: #ff4400;"
        >
          会员中心
        </div>
      </div>
      <div style="width: 400px;height: 200px;float: left;position: relative;">
        <router-link
          to="/"
          style="width: 150px;height: 30px;background-color: #ff4400;border-radius: 5px;color: #FFF;line-height: 30px;text-align: center;position: absolute;bottom: 10px;right: 10px;"
        >
          返回海工人首页
        </router-link>
      </div>
    </div>

    <div
      style="width: 500px;height: 500px;position: fixed;top: 10%;left: 30%;z-index: 99;padding-left: 10px;padding-right: 10px;border: 2px solid #6e6e6e;background: #FFF;overflow: scroll;"
      v-if="ioioio"
    >
      <div style="width: 100%;height: 30px;">
        <div
          style="width: 30px;height: 30px;float: right;font-size: 26px;font-weight: 600;"
          @click="ioioio = false"
        >
          X
        </div>
        <div style="width: 350px;height: 30px;line-height: 30px;">
          可提现余额: <span style="color: #ff4400;">{{ contems.rmb }}</span>
          <span style="margin-left: 30px;">提现收取%2的手续费</span>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="提现金额">
          <el-input v-model="money"></el-input>
        </el-form-item>
        <el-form-item label="实际到账金额">
          <el-input v-model="money * 0.98" disabled></el-input>
          <!-- <el-select v-model="money" placeholder="快捷选择金额">
						<el-option label="5元" value="5"></el-option>
						<el-option label="10元" value="10"></el-option>
						<el-option label="30元" value="30"></el-option>
						<el-option label="50元" value="50"></el-option>
					</el-select> -->
        </el-form-item>
        <el-form-item label="提现人姓名">
          <el-input v-model="truename"></el-input>
        </el-form-item>
        <el-form-item label="提现人手机">
          <el-input v-model="tel"></el-input>
        </el-form-item>
        <el-form-item label="银行卡名称">
          <el-input v-model="banktype"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号">
          <el-input v-model="bankname"></el-input>
        </el-form-item>
        <!-- <el-form-item label="开户行账号">
					<el-input v-model="form.bankname"></el-input>
				</el-form-item> -->
        <el-form-item label="开户地址">
          <el-input v-model="address"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="why"></el-input>
        </el-form-item>
        <el-form-item label="提现方式">
          <el-input v-model="tx_type" disabled></el-input>
        </el-form-item>
        <!-- <el-form-item label="提现方式">
					<el-select v-model="bankname" placeholder="请选提现方式">
						<el-option v-for="(item,index) in qbe" :key="index" :value="item.value" :label="item.label"></el-option>
						<el-option label="银行卡" value="银行卡"></el-option> 
					</el-select>
				</el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即提现</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 中间部分 -->
    <div class="usercent">
      <!-- 左 -->
      <div class="usercent_L">
        <ul style="width: 100%;margin: 0;padding: 0;">
          <li class="usercent_L_lis">个人中心</li>
          <router-link
            tag="li"
            :to="item.link"
            class="usercent_L_li"
            v-for="(item, index) in list"
            :key="index"
            :class="{ xncf: isActive == item.id }"
            @click.native="gbActive(item.id)"
          >
            <span :class="item.icon">&nbsp;&nbsp;</span>{{ item.title }}
          </router-link>
        </ul>
      </div>
      <!-- 右 -->
      <div class="usercent_R">
        <!-- 个人信息，广告 -->
        <div class="User_R_top">
          <div class="user_L">
            <div style="width: 70%;height: 300px;float: left;">
              <div style="height: 120px;">
                <div style="height: 20px;"></div>
                <div
                  style="width: 80px;height: 80px;margin-left: 20px;border-radius: 50%;overflow: hidden;float: left;"
                >
                  <img
                    v-lazy="
                      'https://admin.shipoe360.com/public/' + contems.icon
                    "
                    style="width: 100%;height: 100%;"
                    alt=""
                  />
                </div>
                <div
                  style="width: 150px;height: 100px;float: left;padding-left: 20px;"
                >
                  <div
                    style="height: 50px;line-height: 50px;font-size: 20px;font-weight: 800;"
                  >
                    {{ contems.nickname }}
                  </div>
                  <div style="height: 20px;line-height: 20px;">
                    <span>级别:</span>
                    <span v-if="contems.groupid == 3">超级管理员</span>
                    <span v-if="contems.groupid == 8">普通会员</span>
                    <span v-if="contems.groupid == 11">vip会员</span>
                  </div>
                  <div>ID:{{ contems.uid }}</div>
                </div>
              </div>
              <div class="1" style="width: 100%;height: 40px;"></div>
              <div style="height: 80px;text-align: center;">
                <div style="width: 50%;height: 80px;float: left;">
                  <div
                    style="height: 40px;line-height: 40px;font-weight: 800;color: #ff4400;"
                  >
                    {{ contems.rmb }}
                  </div>
                  <div style="height: 40px;line-height: 40px;font-size: 14px;">
                    可用余额
                  </div>
                </div>
                <div style="width: 50%;height: 80px;float: left;">
                  <div
                    style="height: 40px;line-height: 40px;font-weight: 800;color: #ff4400;"
                  >
                    {{ contems.money }}
                  </div>
                  <div style="height: 40px;line-height: 40px;font-size: 14px;">
                    积分(个)
                  </div>
                </div>
              </div>
              <div
                style="height: 100px;font-size: 14px;text-align: center;line-height: 40px;"
              >
                <!-- <span style="display: block;height: 58px;line-height: 40px;" @click="symxa">收益明细</span> -->
                <span class="el-icon-time"></span>
                <span>注册时间：</span>
                <span>{{ getLocalTime(contems.regdate) }}</span>
              </div>
            </div>
            <div
              style="width: 30%;height: 300px;float: left;position: relative;"
            >
              <div
                style="width: 100px;height: 30px;background-color: #ff4400;right: 0px;top: 10px;position: absolute;border-radius: 20px 0 0 20px;font-weight: 800;color: #FFF;text-align: center;line-height: 30px;"
              >
                个人主页
              </div>
              <div style="height: 150px;"></div>
              <div
                @click="symxa"
                style="height: 30px;width: 100px;background-color: rgb(255, 68, 0);line-height: 30px;text-align: center;color: #FFF;border-radius: 5px;"
              >
                收益明细
              </div>
              <div style="height: 20px;"></div>
              <div
                @click="cnmcz(contems.uid)"
                style="height: 30px;width: 100px;background-color: red;line-height: 30px;text-align: center;color: #FFF;border-radius: 5px;"
              >
                充值
              </div>
              <div style="height: 20px;"></div>
              <div
                @click="txaaaa()"
                style="height: 30px;width: 100px;background-color: olive;line-height: 30px;text-align: center;color: #FFF;border-radius: 5px;"
              >
                提现
              </div>
            </div>
          </div>
          <div class="user_R">
            <img
              src="../../imges/user/lb_03.jpg"
              alt=""
              style="width: 100%;height: 100%;"
            />
          </div>
        </div>
        <!-- 内容 -->
        <div class="User_R_bottom">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <!-- <dashang ref="child" :dsje="dsje"></dashang> -->
    <dashang ref="dashang"></dashang>
    <!-- 尾标签 -->
    <myfooter></myfooter>
  </div>
</template>

<script>
import http from "@/utils/http";
export default {
  data() {
    return {
      amounts: "", //其他金额
      ioioio: false,
      qbe: [
        {
          value: "银行卡",
          label: "银行卡",
        },
      ],
      bankname: "",
      address: "",
      tx_type: "银行卡",
      why: "",
      truename: "",
      tel: "",
      money: "",
      form: {
        tel: "",
        banktype: "",
        why: "",
        region: "",
        imageUrl: "",
      },
      list: [
        {
          id: 1,
          icon: "el-icon-setting",
          title: "基础设置",
          link: "/user/jcsz",
        },
        {
          id: 23,
          icon: "el-icon-office-building",
          title: "企业管理",
          link: "/user/qygl",
        },
        {
          id: 36,
          icon: "el-icon-user-solid",
          title: "信息查看",
          link: "/user/zndxx",
        },
        // {
        // 	id: 14,
        // 	icon: 'el-icon-collection-tag',
        // 	title: '认证管理',
        // 	link: '/user/rzgl',
        // }, {
        // 	id: 11,
        // 	icon: 'el-icon-s-order',
        // 	title: '任务项目管理',
        // 	link: '/user/rwxm',
        // },
        {
          id: 9,
          icon: "el-icon-mobile",
          title: "名片收益管理",
          link: "/user/mp",
        },
        {
          id: 33,
          icon: "el-icon-s-custom",
          title: "专家智库",
          link: "/user/zjzk",
        },
        {
          id: 7,
          icon: "el-icon-user",
          title: "交流中心",
          link: "/user/dkyj",
        },
        {
          id: 13,
          icon: "el-icon-film",
          title: "视频播放",
          link: "/user/spzx",
        },
        {
          id: 17,
          icon: "el-icon-picture",
          title: "船舶船型",
          link: "/user/tkgl",
        },
        {
          id: 18,
          icon: "el-icon-files",
          title: "行业资讯",
          link: "/user/hyzx",
        },
        {
          id: 10,
          icon: "el-icon-s-cooperation",
          title: "人才招聘",
          link: "/user/rczp",
        },
        // {
        // 	id: 15,
        // 	icon: 'el-icon-full-screen',
        // 	title: '企业二维码展示申请',
        // 	link: '/user/ewmzssq',
        // },
        {
          id: 19,
          icon: "el-icon-box",
          title: "新品推荐",
          link: "/user/xptj",
        },
        {
          id: 4,
          icon: "el-icon-video-play",
          title: "展会会议",
          link: "/user/zh",
        },
        {
          id: 5,
          icon: "el-icon-s-opportunity",
          title: "会员活动",
          link: "/user/hyhd",
        },
        {
          id: 99,
          icon: "el-icon-star-on",
          title: "我的收藏",
          link: "/user/sc",
        },
        {
          id: 102,
          icon: "el-icon-s-finance",
          title: "账户明细",
          link: "/user/zhmx",
        },
        {
          id: 103,
          icon: "el-icon-s-management",
          title: "期刊阅读",
          link: "/user/gjqk",
        },
        {
          id: 104,
          icon: "el-icon-s-platform",
          title: "PPT分享",
          link: "/user/pptfx",
        },
        {
          id: 105,
          icon: "el-icon-s-platform",
          title: "直播互动",
          link: "/user/zbhd",
        },
        // {
        // 	id: 105,
        // 	icon: 'el-icon-magic-stick',
        // 	title: '招标通告',
        // 	link: '/user/zbtg',
        // },
      ],
      isActive: 1,
      contems: "",
      cnmuid: "",
      banktype: "",
      form: [],
      xzzfs: 1, //支付金额
      dsje: [
        {
          tid: "",
          nologin_type: "cz",
          name: "充值",
          price: 0,
        },
      ],
    };
  },
  components: {
    // 尾标签,
    myfooter: (resolve) => require(["@/components/myfooter"], resolve),
    //打赏
    dashang: (resolve) =>
      require(["@/components/dashang/dashang.vue"], resolve),
  },
  async mounted() {
    this.getinfo();
    if (this.isActive == 1) {
      this.$router.push("/user/jcsz");
    }
  },
  methods: {
    gbActive(val) {
      this.isActive = val;
      this.backTop();
    },
    symxa() {
      this.$router.push("/user/symx");
    },
    backTop() {
      let that = this;
      let speed = Math.floor(that.scrollTop / 10);
      document.documentElement.scrollTop = document.body.scrollTop =
        that.scrollTop + speed;
      if (that.scrollTop === 0) {
        clearInterval(timer);
      }
    },
    async onSubmit() {
      const loginInfo = JSON.parse(
        window.sessionStorage.getItem("user") || null
      );
      if (Number(this.money) > Number(this.contems.rmb)) {
        alert("余额不足");
        return false;
      } else {
        if (!/^1[3|4|5|6|7|8|9]{1}(\d){9}$/.test(this.tel.trim())) {
          this.$message({
            showClose: true,
            message: "请输入正确的手机号",
            type: "error",
          });
          return;
        }
        if (!/^(\d){9,18}$/.test(this.bankname.trim())) {
          this.$message({
            showClose: true,
            message: "请输入正确的银行卡号",
            type: "error",
          });
          return;
        }
        let res = await http.post("api/picture/tx_offer", {
          uid: loginInfo.id,
          money: this.money,
          banktype: this.banktype,
          bankname: this.bankname,
          real_money: this.money * 0.98,
          address: this.address,
          why: this.form.why,
          truename: this.truename,
          tel: this.tel,
          tx_type: "银行卡",
        });
        console.log(res);
        if (res.data.msg == "success") {
          this.ioioio = false;
          this.getinfo();
          alert("提现成功，等待审核");
        } else {
          alert("提现失败联系管理员");
        }
      }
    },
    gb_ZF() {
      this.ioioio = false;
      // this.isShowZF = false;
      // this.qrcode = ''
    },
    cnmcz(id) {
      // this.dsje[0].tid = id
      // this.dsje[0].tid = this.dsje[0].tid = id
      // this.$refs.child.isShowZF = true //修改子组件data
      this.$refs.dashang.DS_ck(0, "充值", "cz", id);
    },
    txaaaa() {
      this.ioioio = true;
    },
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    },
    async getinfo() {
      const loginInfo = JSON.parse(
        window.sessionStorage.getItem("user") || null
      );
      this.cnmuid = loginInfo.id;
      let res = await http.get("api/picture/grzx", {
        uid: this.cnmuid,
      });
      this.contems = res.data.data[0];
    },
  },
};
</script>

<style>
.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);

  .zf_warp {
    position: relative;
    top: 50%;
    margin: 0 auto;
    margin-top: -270px;
    width: 600px;
    background-color: #fff;

    .gb_sqewm {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      width: 20px;
      height: 20px;
      background-color: #a0bdd8;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .ZF_title {
    background-color: #a0bdd8;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 4px;
    padding-left: 18px;
  }

  .dsje_warp {
    display: flex;
    margin-left: 20px;
    margin-top: 5px;

    .color_style {
      border: 1px solid #ff4400 !important;
    }

    .dsje_title {
      float: left;
      font-size: 14px;
    }

    .dsjr_je {
      float: left;
      margin-left: 20px;

      > div {
        position: relative;
        float: left;
        height: 45px;
        width: 80px;
        text-align: center;
        line-height: 45px;
        border: 1px solid #c0bfbf;
        margin-left: 20px;
        cursor: pointer;

        > div {
          height: 20px;
          width: 20px;
          position: absolute;
          bottom: 13px;
          right: -2px;

          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .qtjr_je {
      float: left;
      margin-left: 40px;
      flex: 1;

      .input_sty {
        float: left;
        width: 200px;
      }

      .txbz_sty {
        float: left;
        width: 140px;
        margin-left: 20px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #257beb;
      }
    }
  }

  .zffs_warp {
    height: 50px;
    margin-left: 20px;
    margin-top: 12px;

    .color_style {
      border: 1px solid #ff4400 !important;
    }

    .dsje_title {
      float: left;
      font-size: 14px;
    }

    .zffs_je {
      float: left;
      margin-left: 20px;

      > div {
        position: relative;
        float: left;
        height: 45px;
        width: 120px;
        text-align: center;
        line-height: 45px;
        border: 1px solid #c0bfbf;
        margin-left: 20px;
        overflow: hidden;
        cursor: pointer;

        .xz {
          height: 20px;
          width: 20px;
          position: absolute;
          bottom: 13px;
          right: -2px;

          > img {
            width: 100%;
            height: 100%;
          }
        }

        .zf_img {
          margin-top: -3px;
          height: 40px;
          margin-left: 10px;
          width: 90px;
          overflow: hidden;

          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .qtjr_je {
      float: left;
      margin-left: 40px;

      .input_sty {
        float: left;
        width: 200px;
      }

      .txbz_sty {
        float: left;
        width: 140px;
        margin-left: 20px;
        border: 1px solid #97c7f3;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #257beb;
      }
    }
  }
}

.usertenter {
  width: 1300px;
  margin: 0 auto;
}

.usertop {
  width: 100%;
  height: 200px;
  box-shadow: #6e6e6e 0px 0px 10px;
}

.usercent {
  width: 100%;
  margin-top: 25px;
  height: 1900px;
}

.usercent_L {
  width: 20%;
  height: 1900px;
  float: left;
  box-shadow: #6e6e6e 0px 0px 10px;
}

.usercent_R {
  width: 78%;
  margin-left: 2%;
  float: left;
}

.User_R_top {
  width: 100%;
  height: 300px;
}

.User_R_bottom {
  width: 100%;
  box-shadow: #6e6e6e 0px 0px 10px;
  height: 1575px;
  margin-top: 25px;
  overflow: scroll;
}

.user_L {
  width: 40%;
  height: 300px;
  box-shadow: #6e6e6e 0px 0px 10px;
  float: left;
}

.user_R {
  width: 58%;
  margin-left: 2%;
  height: 300px;
  float: left;
  box-shadow: #6e6e6e 0px 0px 10px;
}

.usercent_L_li {
  list-style: none;
  height: 50px;
  width: 90%;
  line-height: 50px;
  padding-left: 10%;
  font-size: 16px;
}

.usercent_L_lis {
  list-style: none;
  height: 50px;
  width: 90%;
  line-height: 50px;
  padding-left: 10%;
  font-size: 20px;
  font-weight: 800;
  color: #ff4400;
}

.usercent_L_li:hover {
  list-style: none;
  height: 50px;
  width: 89%;
  border-left: #ff4400 3px solid;
  background-color: rgba(255, 68, 0, 0.3);
  line-height: 50px;
  font-size: 16px;
  color: #ff4400;
}

.xncf {
  color: #ff4400;
  width: 89%;
  border-left: #ff4400 3px solid;
  background-color: rgba(255, 68, 0, 0.3);
}
</style>
